import Content from "../../../components/Content"
import PlayerStatItem from "../../../components/PlayerStatItem"
import { useAppSelector } from "../../../store/store"

const TeamOverview = () => {
    const team = useAppSelector(state => state.team)
    const teamHistoricalStats = team.stats?.find(((stats) => stats.type === "HISTORIC"))
    return (
        <Content className="flex flex-col gap-5">
            <p className="text-4xl text-zinc-700">Estadísticas</p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
                <div className="flex flex-col gap-5">
                    <p className="text-2xl text-zinc-700">Históricas</p>
                    <PlayerStatItem label="Partidos jugados" value={teamHistoricalStats?.base_stats?.matches_played} />
                    <PlayerStatItem label="Partidos ganados" value={teamHistoricalStats?.base_stats?.matches_won} />
                    <PlayerStatItem label="Partidos empatados" value={teamHistoricalStats?.base_stats?.matches_drawn} />
                    <PlayerStatItem label="Partidos perdidos" value={teamHistoricalStats?.base_stats?.matches_lost} />

                </div>
                <div className="flex flex-col gap-5">
                    <p className="text-2xl text-zinc-700">Temporada</p>
                    <PlayerStatItem label="Partidos jugados" value={teamHistoricalStats?.base_stats?.matches_played} />
                    <PlayerStatItem label="Partidos ganados" value={teamHistoricalStats?.base_stats?.matches_won} />
                    <PlayerStatItem label="Partidos empatados" value={teamHistoricalStats?.base_stats?.matches_drawn} />
                    <PlayerStatItem label="Partidos perdidos" value={teamHistoricalStats?.base_stats?.matches_lost} />

                </div>
            </div>
        </Content>
    )
}

export default TeamOverview